import { AppProvider } from "@shopify/polaris";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import PartnerUpProvider from './providers/PartnerUpProvider';
// import Home from './pages/index';
import './App.css'

import '@shopify/polaris/build/esm/styles.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PartnerUpWebProvider from "./providers/PartnerUpStoreProvider";

const pages = import.meta.glob("./pages/**/*.jsx", { eager: true });

const routes = [];
for (const path of Object.keys(pages)) {
  const fileName = path.match(/\.\/pages\/(.*)\.jsx$/)?.[1];
  if (!fileName) {
    continue;
  }

  const normalizedPathName = fileName.includes("$")
    ? fileName.replace("$", ":")
    : fileName.replace(/\/index/, "");

  routes.push({
    path: fileName === "index" ? "/" : `/${normalizedPathName.toLowerCase()}`,
    Element: pages[path].default,
    loader: pages[path]?.loader,
    action: pages[path]?.action,
    ErrorBoundary: pages[path]?.ErrorBoundary,
  });
}

console.log('routes are', routes)

const queryClient = new QueryClient();

const App = () => {
  const router = createBrowserRouter(
    routes.map(({ Element, ErrorBoundary, ...rest }) => ({
      ...rest,
      element: <Element />,
      ...(ErrorBoundary && { errorElement: <ErrorBoundary /> }),
    }))
  );

  return (
    <AppProvider i18n={{}}>
      <QueryClientProvider client={queryClient}>
        <PartnerUpWebProvider>
          <RouterProvider router={router} />
        </PartnerUpWebProvider>
      </QueryClientProvider>
    </AppProvider>
  );
};

export default App;

